import { useState, type CSSProperties } from 'react';
import styles from './MediaImage.module.css';

export interface MediaImageProps {
  src?: string;
  alt: string;
  fit?: 'cover' | 'contain';
  /** Fallback icon/emoji shown when there is no image or it fails to load. */
  fallback?: string;
  className?: string;
  style?: CSSProperties;
}

/** Image with graceful fallback to a hatched placeholder + icon. */
export function MediaImage({
  src,
  alt,
  fit = 'cover',
  fallback = '🖼️',
  className,
  style,
}: MediaImageProps) {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;

  return (
    <div className={[styles.wrap, className].filter(Boolean).join(' ')} style={style}>
      {showPlaceholder ? (
        <div className={styles.placeholder} aria-label={alt} role="img">
          <span aria-hidden>{fallback}</span>
        </div>
      ) : (
        <img
          className={[styles.img, fit === 'contain' ? styles.contain : undefined]
            .filter(Boolean)
            .join(' ')}
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
